var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiftpayLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "w0e92l9t2a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.247059 0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#w0e92l9t2a)",
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1B1C1F",
    d: "M14.035 18.947c.93 0 1.684.707 1.684 1.58 0 .871-.754 1.578-1.684 1.578-.93 0-1.684-.707-1.684-1.579s.754-1.579 1.684-1.579zM9.544 15.79c.93 0 1.684.707 1.684 1.58 0 .871-.754 1.578-1.684 1.578-.93 0-1.684-.707-1.684-1.579s.754-1.579 1.684-1.579zm8.982 0c.93 0 1.685.707 1.685 1.58 0 .871-.755 1.578-1.685 1.578s-1.684-.707-1.684-1.579.754-1.579 1.684-1.579zm-4.49-4.21c.93 0 1.683.707 1.683 1.579s-.754 1.579-1.684 1.579c-.93 0-1.684-.707-1.684-1.58 0-.871.754-1.578 1.684-1.578zm-4.492-4.21c.93 0 1.684.706 1.684 1.578 0 .872-.754 1.58-1.684 1.58-.93 0-1.684-.708-1.684-1.58 0-.872.754-1.579 1.684-1.579zm8.982 0c.93 0 1.685.706 1.685 1.578 0 .872-.755 1.58-1.685 1.58s-1.684-.708-1.684-1.58c0-.872.754-1.579 1.684-1.579zm-4.49-3.158c.93 0 1.683.706 1.683 1.578 0 .873-.754 1.58-1.684 1.58-.93 0-1.684-.707-1.684-1.58 0-.872.754-1.578 1.684-1.578z",
    transform: "translate(-7 6)"
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "#3F3E3E",
    fontFamily: "Raleway-ExtraBold, Raleway",
    fontSize: 16.906,
    fontWeight: 700,
    letterSpacing: 0.317
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 25,
    y: 25
  }, "SwiftPay")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiftpayLogo);
export default __webpack_public_path__ + "static/media/swiftpay-logo.2de595afa634509ddcd52da5d0ab2288.svg";
export { ForwardRef as ReactComponent };